import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '@dashboard/lib/utils';
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '@dashboard/components/ui/collapsible';
import { changeRows } from './aiChangeLocations';
import ChangeRow from './ChangeRow';

export default function ChangeList({ changes, pageType, onShow, onOpen }) {
  const [open, setOpen] = useState(false);
  const rows = changeRows(changes, pageType);
  if (rows.length === 0) return null;
  const touchesProduct = changes.some(change => change.target?.kind === 'product');

  return (
    <Collapsible open={open} onOpenChange={setOpen}>
      <CollapsibleTrigger className="inline-flex items-center gap-1 rounded-sm text-[13px] leading-5 text-muted-foreground outline-none hover:text-foreground focus-visible:ring-2 focus-visible:ring-ring">
        {open ? 'Hide changes' : `Show changes (${rows.length})`}
        <ChevronDown
          aria-hidden="true"
          className={cn('size-3.5 transition-transform', open && 'rotate-180')}
        />
      </CollapsibleTrigger>
      <CollapsibleContent className="mt-2 flex flex-col gap-2.5 border-l pl-3">
        <ul aria-label="Changes" className="flex flex-col">
          {rows.map(row => (
            <ChangeRow key={row.id} row={row} onShow={onShow} onOpen={onOpen} />
          ))}
        </ul>
        {touchesProduct && (
          <p className="text-xs leading-[17px] text-muted-foreground">
            Product changes apply everywhere this product is sold.
          </p>
        )}
      </CollapsibleContent>
    </Collapsible>
  );
}
